import React from 'react';
import AddKnockout from '../../components/knockout/new-knockout';

const NewKnockoutContainer = () => {
    return <AddKnockout />;
};

export default NewKnockoutContainer;
